import { type EntitiesFavorites } from '../../../states/entities/favorites';
import { type StateType } from '../../../states/index';
import { type Selector } from '../../../types/selectors';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyObject = {};
const emptyArray: [] = [];

export const selectEntitiesFavoritesState: Selector<EntitiesFavorites | undefined | null> = (state: StateType) =>
  selectEntitiesState(state).favorites ?? emptyObject;

//#region state.entities.favorites
export const selectEntitiesFavoritesMatchCount: Selector<number> = (state: StateType) =>
  selectEntitiesFavoritesState(state)?.matchCount ?? 0;

export const selectEntitiesFavoritesMatches: Selector<Array<number>> = (state: StateType) =>
  selectEntitiesFavoritesState(state)?.matches ?? emptyArray;
//#endregion
